module.exports = __webpack_public_path__ + "img/img08.46ee80dd.png";